export default "__VITE_ASSET__3JenHV_G__"